// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2doqJ","colBig":"styles_colBig__QMhm-","colSmall":"styles_colSmall__-bIqK"};